import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { ArchiveJob } from '../models/archive-job.model';
import { ArchiveJobSdk } from '../sdks/archive-job.sdk';
import { Collection } from "../models/ui/collection.model";

@Injectable({
	providedIn: 'root'
})
export class ArchiveJobManager {
	public archiveJobCollection$: Observable<Collection<ArchiveJob>>;
	public currentArchiveJob$: Observable<ArchiveJob>;

	private archiveJobCollectionSource: BehaviorSubject<Collection<ArchiveJob>> = new BehaviorSubject<Collection<ArchiveJob>>(null);
	private currentArchiveJobSource: BehaviorSubject<ArchiveJob> = new BehaviorSubject<ArchiveJob>(null);

	constructor(private archiveJobSdk: ArchiveJobSdk) {
		this.archiveJobCollection$ = this.archiveJobCollectionSource.asObservable();
		this.currentArchiveJob$ = this.currentArchiveJobSource.asObservable();
	}

	public getArchiveJobs(params: RefreshArchiveJobsParams): void {
		this.archiveJobSdk.list(params?.skip || 0, params?.take || 200)
			.subscribe((response: Collection<ArchiveJob>) => this.archiveJobCollectionSource.next(response));
	}

	public setCurrentArchiveJob(archiveJobId: string): void {
		this.archiveJobSdk.get(archiveJobId)
			.subscribe((response) => this.currentArchiveJobSource.next(response));
	}

	public saveArchiveJob(archiveJob: ArchiveJob): Observable<void> {
		return this.archiveJobSdk.put(archiveJob);
	}

	public delete(id: string): Observable<void> {
		return this.archiveJobSdk.delete(id);
	}

	public createArchiveJob(title: string): Observable<any> {
		const archiveJob = new ArchiveJob();
		archiveJob.title = title;

		archiveJob.comments = '';
		archiveJob.dateTimeCreated = new Date();
		archiveJob.dateTimeRun = null;
		archiveJob.archiveBaseNumberDigits = 8;
		archiveJob.archiveBaseNumberStart = 1;

		return this.archiveJobSdk.create(archiveJob);
	}
}

interface RefreshArchiveJobsParams {
	skip: number;
	take: number;
}
